<template>
  <PageMain
    :loading="loading"
    :tableData="tableData"
    :tablePage="page"
    :selectedIds="selectedIds"
    @reload="reload"
    @select="(row) => $emit('select', row)"
    @remove="(row) => $emit('remove', row)"
  >
    <template #header>
      <PageHeader ref="header" @query="getData" @reset="resetPage" />
    </template>

    <template #pager>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        :layouts="['Total', 'Sizes', 'PrevPage', 'Number', 'NextPage']"
        @change="handlePaginationChange"
      />
    </template>
  </PageMain>
</template>

<script>
import lodash from 'lodash'
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageMain, PageHeader },
  mixins: [BaseTable],
  props: { data: { type: Array, default: () => [] } },
  data() {
    return { usePage: true }
  },
  computed: {
    selectedIds() {
      return lodash.map(this.data, 'userCode')
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sysUserList({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped></style>
